/** True when the student is classified as having an EHCP (top-level or nested flag). */
export function studentHasEhcp(student) {
  return Boolean(student?.hasEHCP || student?.ehcp?.hasEHCP);
}
